// extracted by mini-css-extract-plugin
export default {"root":"CourseError_root__KMWKo","main":"CourseError_main__ZK3py"};